"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.__exports={};
//# sourceMappingURL=react-is.development2.js.map
